import React from 'react'
import { getPublicTables } from '../../routes'
import { fromJS } from 'immutable'
import Paths, { openRoute } from '../../router'
import { withRouter } from 'react-router-dom'
import { timeLimitToString } from '../../util'

class PublicTablesComponent extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            tables: null
        }

        this._isMounted = true
        this._reloadTables()
    }

    componentWillUnmount()
    {
        this._isMounted = false
    }

    _reloadTables()
    {
        const then = () => {
            if (this._isMounted) {
                setTimeout(this._reloadTables.bind(this), 1500)
            }
        }

        getPublicTables(
            resp => this.setState({ tables: fromJS(resp) }, then),
            err => {
                this.setState({ tables: null }, then)
                console.error(err)
            }
        )
    }

    render()
    {
        let content

        const t = this.state.tables

        if (!t || !t.size) {
            content = (
                <div>{ Messages("welcome.public-tables.none") }</div>
            )
        } else {
            content = t.map(table => {
                let description = Messages("welcome.public-tables.players", table.get("playerCount") + " / 4")
                description += ", " + timeLimitToString(table.get("timeLimit"))

                if (table.getIn(["tableSettings", "withPigletEvolutions"])) {
                    description += ", " + Messages("table.table-settings.with-piglet-evolutions.key")
                }

                return (
                    <div
                        key={ table.get("code") }
                        onClick={ () => openRoute(this.props.history, Paths.Table.JOIN, table.get("code")) }
                        className="table-item dk-box clickable">
                        <div style={{ fontWeight: "bold" }}>{ table.get("code") }</div>
                        <div>{ description }</div>
                        <div>{ Messages("welcome.public-tables.creator", table.get("creator")) }</div>
                    </div>
                )
            })
        }


        return (
            <div className="public-table-list">
                { content }
            </div>
        )
    }

}

export const PublicTables = withRouter(PublicTablesComponent)

export default PublicTables